import {  useEffect } from 'react'
import { userManager } from '@/auth/config'
import '@/shared/styles/global.css'
import { clearAuthAttempts } from '@/app/authAttempts'

// Public signed-out landing page (the post_logout_redirect_uri). Deliberately
// NOT under AuthGuard: landing on any guarded route after logout would
// immediately auto-signinRedirect, and a surviving SSO session would silently
// sign the user straight back in - the exact loop this page exists to break.
export function SignedOut() {
  useEffect(() => {
    // Completes the RP-initiated logout response (clears the pending signout
    // state oidc-client-ts stashed before redirecting). Best-effort: the local
    // user was already removed before the redirect, and a missing/consumed
    // state param (direct visit, StrictMode re-run) is not an error here.
    userManager.signoutRedirectCallback().catch(() => {})
    clearAuthAttempts()
  }, [])
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 12, padding: 24, textAlign: 'center', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'var(--body)' }}>
      <h1 style={{ fontFamily: 'var(--head)', fontSize: '1.4rem', margin: 0 }}>Signed out</h1>
      <p style={{ color: 'var(--text2)', fontSize: '0.9rem', margin: 0 }}>You've been signed out of Terramantle.</p>
      <button
        className="btn btn-primary"
        style={{ marginTop: 8 }}
        onClick={() => { clearAuthAttempts(); window.location.replace('/') }}
      >
        Sign back in
      </button>
    </div>
  )
}
